module.exports = __webpack_public_path__ + "static/media/teampulse-start.b5a12154.svg";